import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Trạng thái rỗng. Nói CHUYỆN GÌ ĐANG XẢY RA và LÀM GÌ TIẾP — hai thứ đó thôi.
 *
 * Không hình minh hoạ, không icon to giữa màn hình: màn hình rỗng đã đủ nói
 * rằng chưa có gì, vẽ thêm một cái hộp rỗng nữa không giúp ai cả.
 */
export function EmptyState({
  title,
  action,
  className,
}: {
  title: ReactNode
  /** Một hành động, không phải ba. Rỗng thì bỏ qua. */
  action?: ReactNode
  className?: string
}) {
  return (
    <div data-slot="empty" className={cn('flex flex-col items-center justify-center gap-4 px-6 py-16 text-center', className)}>
      <p className="text-sm text-muted">{title}</p>
      {action}
    </div>
  )
}
